var render = function render(){var _vm=this,_c=_vm._self._c;return _c('system-frame',{attrs:{"breadcrumb":false,"system-no":_vm.systemNo,"show-left-menus":false}},[_c('router-view',{attrs:{"slot":"routerView"},slot:"routerView"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }